import { getVerseOA } from "../utils/fetch.js";
import { ApiData } from "../schema/apiData.js";
import { Item, ParentItem } from "../schema/item.js";
import { calcCheckStats } from "./tsx/cell/check.jsx";

export const fetchVerseOAData = async (): Promise<ParentItem[]> => {
  const rawData = (await getVerseOA()) as unknown[];
  const datum = ApiData.initByArray(rawData);
  if (ApiData.hasErrors(datum)) throw "Response is not valid.";
  return parseData(datum);
};

const parseData = (datum: ApiData[]): ParentItem[] => {
  const result: ParentItem[] = [];
  const nameMap = new Map<string, ParentItem>();
  let [childIndex, parentIndex] = [0, 0];
  datum.forEach((data) => {
    const item = data.convertToItem();
    let parent: ParentItem;

    if (nameMap.has(data.name)) {
      parent = nameMap.get(data.name) as ParentItem;
    } else {
      parent = {
        id: `oa-parent-${parentIndex++}`,
        name: item.name,
        childCheckState: { owned: 0, total: 0, comp: false },
        sec: item.sec,
        star: item.star,
        brand: item.brand,
        itemID: "",
        qr: "",
        children: [],
        element: document.createElement("tr"),
        rowState: {
          open: false,
          selected: false,
        },
      };
      nameMap.set(data.name, parent);
      result.push(parent);
    }

    item.id = `oa-child-${childIndex++}`;
    item.itemID = data.id;
    item.parentID = parent.id;
    item.rowState = { selected: false };
    parent.children.push(item);
  });
  result.forEach((item) => {
    item.children = createSetItems(item);
    if (hasOAFSetItem(item)) {
      item.children = item.children
        .filter((child) => child.itemType === "set")
        .map((child) => ({ ...child, check: true }));
    }
    item.childCheckState = calcCheckStats(item);
  });
  return result;
};

const findSetQR = (tops: Item, bottoms: Item) => {
  return tops.setQR ?? bottoms.setQR ?? "";
};

const createSetItems = (parent: ParentItem): Item[] => {
  const tops = parent.children.find((child) => child.term === "トップス");
  const bottoms = parent.children.find((child) => child.term === "ボトムス");
  if (!tops || !bottoms) return parent.children;
  const setQR = findSetQR(tops, bottoms);

  const setItem: Item = {
    id: `${parent.id}-set`,
    name: parent.name,
    check: tops.check && bottoms.check,
    sec: tops.sec,
    star: tops.star,
    brand: tops.brand,
    term: tops.term,
    itemID: `${tops.itemID}_${bottoms.itemID}`,
    qr: setQR,
    point: "",
    url: "",
    parentID: parent.id,
    element: document.createElement("tr"),
    rowState: { selected: false },
    itemType: "set",
    setItems: [tops, bottoms],
  };

  return [
    setItem,
    ...parent.children.filter(
      (child) => child.term !== "トップス" && child.term !== "ボトムス"
    ),
  ];
};

const hasOAFSetItem = (parent: ParentItem) => {
  return parent.children.some(
    (child) =>
      child.itemType === "set" && child.itemID.startsWith("OAF") && child.qr
  );
};
